var key = "";
Shopify.queue = [];
Shopify.moveAlong = function (key) {
  if (Shopify.queue.length > 0) {
    var request = Shopify.queue.shift();
    Shopify.addItem(
      request.variantId,
      request.quantity,
      request.properties,
      Shopify.moveAlong
    );
  } else {
    new theme.CartDrawer();
    $(".site-nav__icons .site-nav__link.js-drawer-open-cart .cart-link").trigger("click");
    // ADD CART RENDER CODE HERE
    // jQuery(".box_product_wrapper").removeClass("loading");
    // window.location.href = "/cart";
  }
};
Shopify.addItem = function (id, qty, properties, callback) {
  var params = {
    quantity: qty,
    id: id,
  };
  if (properties && properties != false && properties !== undefined) {
    if (properties.indexOf("||") > -1) {
      let prop = properties.split("||");
      params.properties = { "Delivery Date": prop[0], Box: prop[1] };
    } else {
      params.properties = { "Delivery Date": properties };
    }
    if (key && key !== "" && key !== undefined) {
      params.properties["code"] = key;
    }
  }
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: params,
    success: function (response) {
      // new theme.CartDrawer();
      // $(".site-nav__icons .site-nav__link.js-drawer-open-cart .cart-link").trigger("click");
      if (typeof callback === "function") {
        if (response.handle == "build-a-box") {
          key = response.key.split(":")[1];
        }
        callback(key);
      }
    },
    error: function (error) {
      $(".multi_qty_error").show();
      console.log("select available variant!");
      jQuery(".custom-accessories-list .alert")
        .addClass("alert--error")
        .text(error.responseJSON.description);
    },
  });
};
function push_to_queue(array) {
  jQuery(".box_product_wrapper").addClass("loading");
  var newArray = array.split(",");
  var total_qty = 0;
  for (var i = 0; i < newArray.length; i++) {
    var product = newArray[i].split(":");
    total_qty += parseInt(product[1]);
  }
  for (var i = 0; i < newArray.length; i++) {
    var product = newArray[i].split(":");
    var params = [];
    Shopify.queue.push({
      variantId: product[0],
      quantity: product[1],
      properties: product[2],
    });
  }
  Shopify.moveAlong((key = ""));
}
